import ChartingBaseController from './charting_base_controller';

export default class extends ChartingBaseController {
  static targets = ['row'];

  static values = {
    actions: { type: Array, default: [] },
    paginationKeys: { type: Array, default: [] },
    paginationLimit: { type: Number, default: 0 }
  };

  rowTargetConnected(row) {
    // eslint-disable-next-line no-param-reassign -- DOM target is meant to be mutated
    row.style.cursor = 'pointer';
    row.addEventListener('click', (event) => this.handleRowClick(event, row));
  }

  handleRowClick(_event, row) {
    const action = this.actionsValue.find((a) => a.trigger === 'pick');
    if (!action) return;

    const member = Object.keys(action.write?.filters || {})[0];
    if (!member) return;

    const value = row.dataset[member];
    if (value === undefined || value === null) return;

    this.applyActions([action], { value });
  }

  /**
   * A header only ever touches its own member — other sorted columns stay
   * untouched, and their relative priority comes from the item's reaction order,
   * not from click order. Re-sorting returns to the first page, since the old
   * page points into a row ordering that no longer exists.
   */
  sort(event) {
    const form = this.formWriter;
    if (!form) return;

    const { sortKeys, sortDirection } = event.currentTarget.dataset;

    JSON.parse(sortKeys).forEach((key) => form.setSort(null, key, sortDirection));
    this.#setPage(form, 0);
    form.submit();
  }

  page(event) {
    const form = this.formWriter;
    if (!form) return;

    this.#setPage(form, event.currentTarget.dataset.page);
    form.submit();
  }

  /**
   * Keys arrive already namespaced by the server, so they are written into
   * the global namespace verbatim.
   */
  #setPage(form, page) {
    this.paginationKeysValue.forEach((key) => {
      form.setPagination(null, key, page, this.paginationLimitValue);
    });
  }
}
